var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0364 2.5C6.0364 3.88071 4.85606 5 3.40004 5C1.94401 5 0.763672 3.88071 0.763672 2.5C0.763672 1.11929 1.94401 0 3.40004 0C4.85606 0 6.0364 1.11929 6.0364 2.5Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading2);
export default __webpack_public_path__ + "static/media/loading2.6ac28a567c070f27b685376afe440cfa.svg";
export { ForwardRef as ReactComponent };